var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSharpieStrokeBold(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 426 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.396 7.928c44.98-.03 89.96-.06 134.94-.081 22.625-.01 45.26-.03 67.885-.04 22.085-.01 44.18-.213 66.265.233 24.876.496 49.801 1.955 74.357 6.21.27-1.985.53-3.981.8-5.967C332.162 4.199 282.581 1.29 232.94.339c-49.301-.943-98.652.02-147.843 3.658a1286.39 1286.39 0 00-82.949 8.815c-3.35.466-2.55 6.13.8 5.968 54.653-2.665 109.325-5.31 164.037-6.272 54.602-.952 109.264-.233 163.736 3.891 30.627 2.32 61.184 5.715 91.531 10.487.27-1.986.53-3.982.8-5.968l-134.88-5.198c-44.82-1.723-89.64-3.455-134.47-5.178L77.885 7.624c-3.86-.152-3.86 5.928 0 6.08l134.88 5.198c44.82 1.722 89.64 3.455 134.47 5.177l75.817 2.919c3.311.131 4.181-5.442.8-5.968C369.65 12.518 314.888 8.262 260.086 6.753c-54.952-1.52-109.935-.355-164.857 1.773C64.462 9.722 33.706 11.21 2.95 12.71c.27 1.986.53 3.982.8 5.968 48.82-6.83 98.062-10.558 147.333-11.957 49.2-1.398 98.441-.486 147.582 2.017 27.676 1.408 55.333 3.323 82.959 5.603 3.33.274 4.141-5.39.8-5.968-43.9-7.62-88.62-6.688-132.99-6.667l-135.77.09c-25.425.011-50.841.031-76.267.052-3.86 0-3.87 6.08 0 6.08z",
    fill: "#000"
  })));
}

export default SvgSharpieStrokeBold;